import React, { PureComponent } from "react";

class Setting extends PureComponent {
    render() {
        return (
            <>
                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12.4985" cy="14.4458" r="7.24343" stroke="black" strokeWidth="0.6" />
                    <circle cx="12.4976" cy="14.4449" r="5.95735" stroke="black" strokeWidth="0.6" />
                    <path d="M8.09375 3.01172L11.9853 6.90234H12.5582M16.9067 3.01172L13.0161 6.90234H12.5582M12.5582 3.01172V6.90234" stroke="black" strokeWidth="0.6" />
                </svg>
            </>
        );
    }
}

export default Setting;